export { default } from "ember-page-title/helpers/page-title";
